import type {
  EnhancedConfigTypeId,
  EnhancedLanguageId,
  EnhancedMarketId,
  EnhancedVehicleTypeId,
  EnhancedViewId,
} from '#api/enhancements/enhancedTmsApiTypes'
import type { EcmSpecificConversionParameters } from '#api/tmsApiService'
import type { FullApiConfiguration } from '#features/Configuration/ApiConfiguration'
import { isValidPeriod, periodToString } from '#utils/DateString'

export function makeApiConfigurationFromEcmParameters(params: Required<EcmSpecificConversionParameters>) {
  return {
    partPeriod: isValidPeriod(params.partPeriodOverwrite) ? periodToString(params.partPeriodOverwrite) : undefined,
    market: params.ecmParametersOverwrites.marketId as EnhancedMarketId,
    vehicleType: params.ecmParametersOverwrites.vehicleTypeId as EnhancedVehicleTypeId,
    configurationType: params.ecmParametersOverwrites.configurationTypeId as EnhancedConfigTypeId | undefined,
    view: params.ecmParametersOverwrites.viewId as EnhancedViewId,
    language: params.ecmParametersOverwrites.languageId as EnhancedLanguageId | undefined,
  } satisfies FullApiConfiguration
}
